import { type UseFormReturn } from "react-hook-form";
import { type OrderItemConfigurationSchema } from "@/components/OrderItemConfigForm/OrderItemConfigForm.schema";

export const redispatchQuantities = (props: {
  totalQuantities: number;
  methods: UseFormReturn<OrderItemConfigurationSchema>;
}) => {
  // Redefine variables
  const nbOfVersions = props.methods
    .getValues("versions")
    .filter((v) => !v.isDeleted).length;
  const nbOfAddresses = props.methods.watch("versions")[0].dispatches.length;

  // Define values
  const quantityPerDispatch = Math.floor(
    props.totalQuantities / (nbOfVersions * nbOfAddresses)
  );
  let remainder = props.totalQuantities % (nbOfVersions * nbOfAddresses);

  // Redispatche quantities
  props.methods.getValues("versions").forEach((version, versionIndex) => {
    if (!version.isDeleted) {
      version.dispatches.forEach((_, dispatchIndex) => {
        props.methods.setValue(
          `versions.${versionIndex}.dispatches.${dispatchIndex}.quantity`,
          remainder > 0 ? quantityPerDispatch + 1 : quantityPerDispatch
        );
        remainder = remainder - 1;
      });
    }
  });
};
